/* 5 Points Farm — desktop submenus open under the item that opened them.
   Horizon's submenu is a full-width panel whose links always start at the left edge, far from an
   item like "Tower Sales" on the right. For a submenu that is only links (no featured products or
   collections), this shifts the links so they start under the item — the panel itself is unchanged.
   Clamped so the links never run past the right edge. Desktop only; nothing else is touched. */
(function () {
  var DESKTOP = window.matchMedia('(min-width: 990px)');

  function align(submenu) {
    var list = submenu.querySelector('.mega-menu__list');
    var grid = submenu.querySelector('.mega-menu__grid');
    var item = submenu.closest('.menu-list__list-item');
    if (!list || !grid || !item) return;
    list.style.transform = '';
    if (!DESKTOP.matches || item.getAttribute('slot') === 'overflow' || grid.querySelector('.mega-menu__content')) return;
    var trigger = item.querySelector('.menu-list__link');
    var links = list.querySelectorAll('.mega-menu__link');
    if (!trigger || !links.length) return;
    var gridRect = grid.getBoundingClientRect();
    var listRect = list.getBoundingClientRect();
    if (!gridRect.width || !listRect.width) return;
    var contentRight = listRect.left;
    links.forEach(function (link) {
      contentRight = Math.max(contentRight, link.getBoundingClientRect().right);
    });
    var wanted = trigger.getBoundingClientRect().left - listRect.left;
    var room = gridRect.right - contentRight;
    var offset = Math.max(0, Math.min(wanted, room));
    if (offset > 0) list.style.transform = 'translateX(' + Math.round(offset) + 'px)';
  }

  function watch(root) {
    (root || document).querySelectorAll('.menu-list__submenu').forEach(function (submenu) {
      if (submenu.dataset.fpfAligned) return;
      submenu.dataset.fpfAligned = '1';
      // Horizon removes `inert` when it opens a submenu.
      new MutationObserver(function () {
        if (!submenu.inert) requestAnimationFrame(function () { align(submenu); });
      }).observe(submenu, { attributes: true, attributeFilter: ['inert'] });
    });
  }

  function realignOpen() {
    document.querySelectorAll('.menu-list__submenu').forEach(function (submenu) {
      if (!submenu.inert) align(submenu);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watch(); });
  else watch();
  window.addEventListener('resize', realignOpen);
  document.addEventListener('shopify:section:load', function (event) { watch(event.target); });
})();
